exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.my-header[data-v-5adfdbda] {\r\n  border-bottom: 1px solid #E6EAEE;\n}\r\n", ""]);

// exports
